import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import DatePicker from "../DatePicker/DatePicker";
import { Select } from "../../components/tools/SelectorOrText/Select";
import { ProfileMenuContainer } from "../../containers/ProfileMenuContainer/ProfileMenuContainer";
import {
  loadingContracts,
  selectContracts,
  setSelectedContract,
} from "../../redux/reducers/contract-reducer";

import {
  loadingProjects,
  setSelectedProject,
} from "../../redux/reducers/project-reducer";
import {
  selectCompany,
  setStartTime,
  setEndTime,
} from "../../redux/reducers/chart-reducer";

const useStyles = makeStyles((theme) => ({
  selectOption: {
    backgroundColor: theme.palette.common.white,
    width: 175,
  },
  selectOutlined: {
    padding: "8.5px 35px 8.5px 10px",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: "20px",
    paddingLeft: "20px",
  },
  title: {
    marginRight: theme.spacing(4),
  },
  grow: {
    flexGrow: 1,
  },
  toolbar: {
    columnGap: "8px",
  },
  datePicker: {
    margin: "0 0 0 10px",
  },
}));

export const ChartHeader = ({ chartDetail, chartProject }) => {
  const classes = useStyles();
  const { contracts, selectedContract } = useSelector(selectContracts);
  const { startTime, endTime, loading } = useSelector(selectCompany);
  const dispatch = useDispatch();

  const handleContractSelector = (e) => {
    dispatch(setSelectedProject(null));
    dispatch(
      setSelectedContract(contracts.filter((f) => f.id === e.target.value)[0])
    );
  };
  const handleStartDateChange = (date) => {
    dispatch(setStartTime(date));
  };
  const handleEndDateChange = (date) => {
    dispatch(setEndTime(date));
  };
  useEffect(() => {
    dispatch(loadingContracts);
  }, []);

  useEffect(() => {
    if (selectedContract?.id) {
      dispatch(loadingProjects(selectedContract?.id));
    }
  }, [dispatch, selectedContract]);
  return (
    <AppBar position="fixed" elevation={0} className={classes.appBar}>
      <CssBaseline />
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        {!loading && !chartDetail ? (
          <>
            {"C"}
            <Grid item className={classes.datePicker}>
              <DatePicker
                time={startTime}
                handleChange={handleStartDateChange}
              />
            </Grid>
            {"по"}
            <Grid item className={classes.datePicker}>
              <DatePicker time={endTime} handleChange={handleEndDateChange} />
            </Grid>
          </>
        ) : (
          <Typography variant="h6" className={classes.title}>
            Мастер актов
          </Typography>
        )}
      </Grid>
      

         
      <Toolbar className={classes.toolbar}>
        <div className={classes.grow} />
        {!chartProject &&
          <Select
            data={contracts}
            formControlProps={{ variant: "outlined" }}
            selectProps={{
              className: classes.selectOption,
              classes: {
                outlined: classes.selectOutlined,
              },
            }}
            uniqueKey={"header-project"}
            value={selectedContract?.id}
            onChange={handleContractSelector}
          />
        } 
        <ProfileMenuContainer />
      </Toolbar>
    </AppBar>
  );
};
